/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { LiteralOperandExpressionNodeConverter } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/converter/LiteralOperandExpressionNodeConverter";
import { AbstractOperandMultiplexExpressionNodeConverter } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/converter/multiplex/AbstractOperandMultiplexExpressionNodeConverter";
import { ReferenceOperandExpressionNodeConverter } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/converter/ReferenceOperandExpressionNodeConverter";
import { ExpExpressionNodeNodeTypeEnum } from "abweb/generated/abwebinternal/api/dto/ExpExpressionNode";
// import AbstractLeafOperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.AbstractLeafOperandValue;

export class AbstractLeafOperandMultiplexExpressionNodeConverter extends AbstractOperandMultiplexExpressionNodeConverter {
  convert(expExpressionNode) {
    switch (expExpressionNode.nodeType) {
      case ExpExpressionNodeNodeTypeEnum.LITERAL:
        return new LiteralOperandExpressionNodeConverter(this.specification).convert(expExpressionNode);
      case ExpExpressionNodeNodeTypeEnum.REFERENCE:
        return new ReferenceOperandExpressionNodeConverter(this.specification).convert(expExpressionNode);
      default:
        this.reportUnexpectedNodeType(expExpressionNode);
    }
  }
}
//# sourceMappingURL=AbstractLeafOperandMultiplexExpressionNodeConverter.js.map
